import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'emm-menu-search',
    templateUrl: './menu-search.component.html',
    styleUrl: './menu-search.component.scss',
    standalone: false
})
export class MenuSearchComponent {

    @Output() searchButtonClicked = new EventEmitter<string>();
    @Output() clearSearchButtonClicked = new EventEmitter<void>();

    searchFilter = '';

    handleSearchButtonClicked() {
        this.searchButtonClicked.emit(this.searchFilter);
    }

    handleClearSearchButtonClicked() {
        this.clearSearchButtonClicked.next();
    }

    handlePaste(event: ClipboardEvent) {
        const pastedText = event.clipboardData?.getData('text') || '';

        if (pastedText.includes('/')) {
            event.preventDefault();
            this.searchFilter = pastedText;

            // Use setTimeout to ensure change detection completes
            setTimeout(() => {
                this.handleSearchButtonClicked();
            }, 100);
        }
    }
}
